import { render, staticRenderFns } from "./FeverClinicInfo.vue?vue&type=template&id=1dc61d24&scoped=true&"
import script from "./FeverClinicInfo.vue?vue&type=script&lang=js&"
export * from "./FeverClinicInfo.vue?vue&type=script&lang=js&"
import style0 from "./FeverClinicInfo.vue?vue&type=style&index=0&id=1dc61d24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc61d24",
  null
  
)

export default component.exports